<template>
  <el-dialog
    title=""
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div style="width: 98%;margin: 0 auto;" ref="print1">
      <p :style="{textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{title}} 收货签收单</p>
      <div :style="{textAlign:'left',lineHeight:'30px'}">客户：{{customername}} {{customerserial}}<template v-if="linkman">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系人：{{linkman}}</template><template v-if="linkmantel">&nbsp;&nbsp;联系电话：{{linkmantel}}</template><br>
        地址：{{address}}<div style="float: right">签收单号：{{erpserial}}</div></div>
      <div :style="{textAlign:'left',lineHeight:'24px'}">物流公司：{{logisticsco}}&nbsp;&nbsp;&nbsp;&nbsp;快递单号：{{logisticsnum}}<template v-if="expressfee">&nbsp;&nbsp;&nbsp;&nbsp;运费：<b>{{formatMoney(expressfee)}}</b></template></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr>
          <td style="text-align: center;width:110px">订单号</td>
          <td style="text-align: center;min-width:60px">客户单号</td>
          <td style="text-align: center;min-width:120px">产品名称</td>
          <td style="text-align: center;width: 40px" v-if="showDetail && hasLens">眼别</td>
          <td style="text-align: center;width: 45px" v-if="showDetail && hasLens">球镜</td>
          <td style="text-align: center;width: 45px" v-if="showDetail && hasLens">柱镜</td>
          <td style="text-align: center;width: 40px" v-if="showDetail && hasLens">轴位</td>
          <td style="text-align: center;width: 40px" v-if="showDetail && hasLens && hasAdd">ADD</td>
          <td style="text-align: center;width: 80px" v-if="showDetail && hasFrame">型号</td>
          <td style="text-align: center;width: 50px" v-if="showDetail && hasFrame">色号</td>
          <td style="text-align: center;width: 40px">数量</td>
          <td style="text-align: center;width: 50px" v-if="showPrice">单价</td>
          <td style="text-align: center;width: 60px" v-if="showPrice">金额</td>
          <td style="text-align: center;min-width:80px;max-width:120px">备注</td>
        </tr>
        <tr v-for="item in tableData">
          <td style="text-align: left">
            {{item.erpserial}}
          </td>
          <td style="text-align: left">
            {{item.ordernum}}
          </td>
          <td style="text-align: left">
            {{item.seedname}}
          </td>
          <td style="text-align: center" v-if="showDetail && hasLens">{{item.rl}}</td>
          <td style="text-align: right;padding-right: 8px" v-if="showDetail && hasLens">{{item.sph}}</td>
          <td style="text-align: right;padding-right: 8px" v-if="showDetail && hasLens">{{item.cyl}}</td>
          <td style="text-align: center" v-if="showDetail && hasLens">{{item.axis}}</td>
          <td style="text-align: center" v-if="showDetail && hasLens && hasAdd">{{item.addv}}</td>
          <td style="text-align: left" v-if="showDetail && hasFrame">{{item.model}}</td>
          <td style="text-align: left" v-if="showDetail && hasFrame">{{item.color}}</td>
          <td style="text-align: center" :style="{fontWeight: item.isTotal ? 'bold' : 'normal'}">
            {{item.number}}
          </td>
          <td style="text-align: right;padding-right: 8px" v-if="showPrice" :style="{fontWeight: item.isTotal ? 'bold' : 'normal'}">
            {{formatMoney(item.taxprice)}}
          </td>
          <td style="text-align: right;padding-right: 8px" v-if="showPrice" :style="{fontWeight: item.isTotal ? 'bold' : 'normal'}">
            {{formatMoney(item.totalmoney)}}
          </td>
          <td style="text-align: left" :rowspan="showDetail ? item.remarkRowspan : 1" v-if="!showDetail || item.remarkRowspan > 0">
            {{item.shipremark}}
          </td>
        </tr>
      </table>
      <div style="float: right">打单日期：{{printdata}}</div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-checkbox v-model="showDetail" @change="onShowDetailChange" style="float: left;line-height: 28px;">显示订单明细</el-checkbox>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="printWithPrice">打印</el-button>
      <el-button @click="printWithoutPrice">打印（无价格）</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {listScanOrdersByCustomer,getPrintTitle} from "../../../api/set/csagreement";
  import {getShipRemark} from '@/plugin/ordercommon';

  export default {
    name: "ScancodePrint",
    data() {
      return {
        tableData: [],
        tableDataJG: [],
        dialogSeeVisible: false,
        title: '',
        customername: '',
        address:'',
        customerserial: '',
        linkman: '',//联系人(取第一个订单)
        linkmantel: '',//联系电话(取第一个订单)
        logisticsco: '',
        logisticsnum:'',
        expressfee: 0,
        erpserial: '',
        printdata: '',
        showPrice: true,
        // 显示订单明细（与扫码发货页共用同一个localStorage）
        showDetail: false,
        hasLens: false,
        hasFrame: false,
        hasAdd: false,
        // 最近一次listScanOrdersByCustomer返回的{detail,goodsDetail}数据，切换明细勾选时直接重渲染，不重新查询
        cachedItems: [],
        // 当前渲染模式：search=单订单签收单，summary=发货汇总单
        renderMode: '',
      }
    },
    methods: {
      // 打印后不关闭页面（可能需要连续打印带价格、无价格两种单子）
      printWithPrice() {
        this.showPrice = true;
        this.$nextTick(() => {
          this.$print(this.$refs.print1);
        });
      },
      printWithoutPrice() {
        this.showPrice = false;
        this.$nextTick(() => {
          this.$print(this.$refs.print1);
        });
      },
      formatMoney(val) {
        if (!val && val !== 0) return '';
        return Number(val).toFixed(2);
      },
      initData(row) {
        this.logisticsco = row.logisticsco || ''
        this.logisticsnum = row.logisticsnum || ''
        this.tableData = []
        this.tableDataJG = []
        this.cachedItems = []
        this.renderMode = 'search'
        this.customername = ''
        this.address=''
        this.linkman = ''
        this.linkmantel = ''
        this.printdata = ''
        this.orderdate = ''
        this.isPhysicalStore = false
        this.showPrice = true
        this.expressfee = 0
        this.showDetail = localStorage.getItem('scancodeDelivery_showDetail') == '1'
        this.hasLens = false
        this.hasFrame = false
        this.hasAdd = false
        this.dialogSeeVisible = true;
        this.search(row)
      },
      // 扫码发货汇总单打印入口（从ScancodeDelivery调用）
      initDeliverySummary(orderList, logisticsco, logisticsnum, expressfee) {
        this.renderMode = 'summary'
        this.cachedItems = []
        this.tableData = []
        this.tableDataJG = []
        this.logisticsnum = logisticsnum || ''
        this.logisticsco = logisticsco || '配送'
        this.printdata = ''
        this.showPrice = true
        this.expressfee = parseFloat(expressfee) || 0
        this.showDetail = localStorage.getItem('scancodeDelivery_showDetail') == '1'
        this.hasLens = false
        this.hasFrame = false
        this.hasAdd = false
        this.dialogSeeVisible = true;
        if (orderList.length == 0) return;

        var first = orderList[0];
        this.customername = first.customername;
        this.address = first.deliveryaddress;
        this.linkman = first.linkman;
        this.linkmantel = first.linkmantel;
        this.customerserial = first.customerserial;
        this.erpserial = '发货汇总单';
        this.title = '发货汇总单';

        var serials = [];
        for (var i = 0; i < orderList.length; i++) {
          if (orderList[i].erpserial) {
            serials.push(orderList[i].erpserial);
          }
        }
        this.loadScanItems(serials);
      },
      close() {
        this.dialogSeeVisible = false;
      },
      // 签收单内切换"显示订单明细"（与扫码发货页共用同一个localStorage）；
      // 明细数据已缓存，切换只需重新渲染（明细模式逐行显示、非明细模式按商品编码合并）
      onShowDetailChange(val) {
        localStorage.setItem('scancodeDelivery_showDetail', val ? '1' : '0');
        if (this.cachedItems.length > 0) {
          this.renderTable();
        }
      },
      search(row) {
        this.erpserial = row.erpserial
        this.customerserial = row.customerserial
        if (row.erpserial.length < 10) {
          return;
        }
        this.customername = row.customername;
        this.address=row.pname;
        this.orderdate = row.adddate;
        this.isPhysicalStore = (row.status == 20);
        if (row.status == 20)
          this.printdata = row.physicalstore

        var seri=[]
            // 兼容旧格式：分号分隔的订单号列表
            var cols = row.remark.split(';');
            for (var s in cols) {
              if (cols[s]) seri.push(cols[s]);
            }
        if(seri.length==0)
          seri.push("no");

        this.loadScanItems(seri);
      },
      // 按单号查询订单及商品明细（与扫码发货页同一个接口，明细已解析好球镜/柱镜/轴位/ADD/型号/色号并排序）
      loadScanItems(serials) {
        listScanOrdersByCustomer({erpserials: JSON.stringify(serials)}).then(response => {
          if (response.data.code != 0) return;
          var items = response.data.obj || [];
          if (items.length == 0) return;

          // 按传入的单号顺序排列，剩余未匹配的排在后面
          var orderMap = {};
          for (var i = 0; i < items.length; i++) {
            orderMap[items[i].detail.erpserial] = items[i];
          }
          var sorted = [];
          for (var j = 0; j < serials.length; j++) {
            if (serials[j] && orderMap[serials[j]]) {
              sorted.push(orderMap[serials[j]]);
              delete orderMap[serials[j]];
            }
          }
          for (var k in orderMap) {
            sorted.push(orderMap[k]);
          }
          this.cachedItems = sorted;

          // 单订单签收单（发货日志查看入口）：运费从获取的订单信息里取，按订单求和
          if (this.renderMode == 'search') {
            var fee = 0;
            for (var f = 0; f < sorted.length; f++) {
              fee += parseFloat(sorted[f].detail.expressfee) || 0;
            }
            this.expressfee = fee;
          }

          // 取抬头
          var firstDetail = sorted[0].detail;
          this.linkman = firstDetail.linkman;
          this.linkmantel = firstDetail.linkmantel;
          getPrintTitle({applybydserial: firstDetail.applybydserial, currency: firstDetail.currency}).then(resTitle => {
            this.title = resTitle.data.msg.split(';')[0];
          })

          this.renderTable();
          if (!this.isPhysicalStore) {
            this.printdata = this.formatOrderTime(this.orderdate);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      // 从cachedItems构建打印行（按当前showDetail状态决定逐行显示或按商品编码合并）
      renderTable() {
        this.tableData = [];
        this.tableDataJG = [];
        var orderRows = [];
        for (var i = 0; i < this.cachedItems.length; i++) {
          var detail = this.cachedItems[i].detail;
          var goodsDetail = this.cachedItems[i].goodsDetail || [];
          var ordernum = this.getOrderNum(detail.remark);
          for (var j = 0; j < goodsDetail.length; j++) {
            var gd = goodsDetail[j];
            var rl = gd['R/L'] || '';
            if (String(rl).toUpperCase() == 'M') {//M为加工项，不是眼别，不显示
              rl = '';
            }
            var item = {
              _erp: detail.erpserial,//真实订单号（重复订单号隐藏用）
              erpserial: detail.erpserial,
              ordernum: ordernum,
              seedname: gd['产品名称'] || '',
              number: gd['数量'],
              totalmoney: gd['TotalMoneyTax'],//明细行金额（明细表TotalMoneyTax）
              taxprice: (parseFloat(gd['TotalMoneyTax']) || 0) / (parseFloat(gd['数量']) || 1),
              shipremark: getShipRemark(detail.remark).replace(/<br\/>/g, "；"),//发货备注（跨行显示，同一订单只在首行显示）
              goodstype: gd.goodstype || '',
              rl: rl,
              sph: gd['球镜'] || '',
              cyl: gd['柱镜'] || '',
              axis: gd['轴位'] || '',
              addv: gd['ADD'] || '',
              model: gd['型号'] || '',
              color: gd['色号'] != null && gd['色号'] !== '' ? gd['色号'] : (gd['规格'] || ''),
            };
            if (gd.filltemplate == 50) {
              this.tableDataJG.push(item);
            } else {
              orderRows.push({row: item, key: detail.erpserial + '|' + (gd.seedcode || '')});
            }
          }
        }
        // 不显示明细时按订单号+商品编码合并记录（数量、金额相加，单价重算）
        if (!this.showDetail) {
          var mergedMap = {};
          var merged = [];
          for (var m = 0; m < orderRows.length; m++) {
            var o = orderRows[m];
            if (mergedMap[o.key]) {
              mergedMap[o.key].number = (parseFloat(mergedMap[o.key].number) || 0) + (parseFloat(o.row.number) || 0);
              mergedMap[o.key].totalmoney = (parseFloat(mergedMap[o.key].totalmoney) || 0) + (parseFloat(o.row.totalmoney) || 0);
              mergedMap[o.key].taxprice = (parseFloat(mergedMap[o.key].totalmoney) || 0) / (parseFloat(mergedMap[o.key].number) || 1);
            } else {
              mergedMap[o.key] = o.row;
              merged.push(o.row);
            }
          }
          orderRows = [];
          for (var n = 0; n < merged.length; n++) {
            orderRows.push({row: merged[n]});
          }
        }
        // 同一订单号/客户单号只在首行显示（含发货备注跨行处理：同一订单只在首行显示）
        var seenSerial = {};
        for (var a = 0; a < orderRows.length; a++) {
          var r = orderRows[a].row;
          if (seenSerial[r._erp]) {
            r.erpserial = '';
            r.ordernum = '';
            r.shipremark = '';
          } else {
            seenSerial[r._erp] = true;
          }
          this.tableData.push(r);
        }
        for (var b = 0; b < this.tableDataJG.length; b++) {
          var rj = this.tableDataJG[b];
          if (seenSerial[rj._erp]) {
            rj.erpserial = '';
            rj.ordernum = '';
            rj.shipremark = '';
          } else {
            seenSerial[rj._erp] = true;
          }
        }
        this.renderTotals();
        this.calcPrintFlags();
        this.calcRemarkRowspan();
      },
      // 计算备注列的rowspan（明细模式下同一订单的多行合并为一个单元格）
      calcRemarkRowspan() {
        if (this.showDetail) {
          var seen = {};
          for (var i = 0; i < this.tableData.length; i++) {
            var r = this.tableData[i];
            var erp = r._erp;
            if (!erp) {
              r.remarkRowspan = 1;
              continue;
            }
            if (seen[erp] !== undefined) {
              this.tableData[seen[erp]].remarkRowspan++;
              r.remarkRowspan = 0;
            } else {
              seen[erp] = i;
              r.remarkRowspan = 1;
            }
          }
        } else {
          for (var j = 0; j < this.tableData.length; j++) {
            this.tableData[j].remarkRowspan = 1;
          }
        }
      },
      // 合计：不显示销货单/加工单合计行，加工单明细并入列表，只保留一个总计行（始终显示，金额含运费）
      renderTotals() {
        var toN = 0;
        // 金额合计：每行金额已是明细行TotalMoneyTax，直接求和
        var totalAmount = 0;
        for (var i = 0; i < this.tableData.length; i++) {
          toN += this.tableData[i].number;
          totalAmount += parseFloat(this.tableData[i].totalmoney) || 0;
        }
        var toNJG = 0;
        for (var j = 0; j < this.tableDataJG.length; j++) {
          var rj = this.tableDataJG[j];
          toNJG += rj.number;
          totalAmount += parseFloat(rj.totalmoney) || 0;
          this.tableData.push(rj);
        }
        this.tableData.push({
          _erp: '',
          erpserial: '',
          ordernum: '',
          seedname: '总计',
          number: (toNJG + toN),
          totalmoney: totalAmount + Number(this.expressfee || 0),
          taxprice: '',
          shipremark: '',
          isTotal: true,
        });
      },
      // 从订单备注中取客户单号（客户销货单号/客户采购单号/客户单号/验光配镜单号）
      getOrderNum(remark) {
        if (!remark) return '';
        try {
          var temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""));
          for (var i = 0; i < temp.length; i++) {
            var item = temp[i];
            if (item.msg) {
              if (item.uname && ['客户销货单号', '客户采购单号', '客户单号'].indexOf(item.uname) > -1) {
                return item.msg;
              }
              if (item.type == '验光配镜单号') {
                return item.msg;
              }
            }
          }
        } catch (ex) {
        }
        return '';
      },
      // 统计当前数据是否包含镜片/镜架商品（决定是否显示对应列）；ADD 列整列无值时也隐藏
      calcPrintFlags() {
        this.hasLens = false;
        this.hasFrame = false;
        this.hasAdd = false;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodstype == 'lens') {
            this.hasLens = true;
          }
          if (this.tableData[i].goodstype == 'frame') {
            this.hasFrame = true;
          }
          if (this.tableData[i].addv) {
            this.hasAdd = true;
          }
        }
      },
      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute;
      },
      //打单日期使用订单时间（row.adddate），无订单时间时退回当前时间
      formatOrderTime(dateStr) {
        if (!dateStr) return this.formatTime();
        var s = String(dateStr).trim();
        if (s.length >= 16) return s.substring(0, 16);
        return s;
      },
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScancodePrint.vue